module.exports = __webpack_public_path__ + "fonts/sourcesansproextralight.d43fc420.ttf";